import wishlistView from "./wishlistView"
export default wishlistView;
